import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router'
import { Link, useParams } from 'react-router-dom'
import AddMembersToGroupsForm from '../../components/userAndGroupForms/AddMembersToGroupsForm/AddMembersToGroupsForm'

import useRoutes from '../../state/useRoutes'

export default React.memo(function AddMembersToGroupPage() {
  const { uuid } = useParams()
  const uuids = useMemo(() => [uuid!], [uuid])

  const { close } = useOutletContext<any>()

  return <AddMembersToGroupsForm groupUuids={uuids} onClose={close} />
})

export function AddMembersToGroupPageBreadcrumb() {
  const { uuid } = useParams()
  const { t } = useTranslation()
  const routes = useRoutes()
  return <Link to={routes.addMembersToGroups.url({ uuid: uuid! })}>{t('manage group.add to group')}</Link>
}
